/* eslint-disable */

/**
 * SMART-SELECTION VARIANT PICKER
 * - Alle Optionen bleiben klickbar (kein disabled=true).
 * - "Selection-aware" Styling: Zeigt Verfügbarkeit relativ zur Auswahl.
 * - Auto-Fallback: Findet die nächste passende Variante bei ungültigen Kombis.
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product') || this.closest('.card--product') || this.closest('.section');
      this.data = this.getProductData();
      this.optionSelectors = this.querySelectorAll('.option-selector');
      
      // Initiales Setup
      this.variant = this.getSelectedVariant();
      this.updateAvailability();
      this.updateAddToCartButton();
      
      this.addEventListener('change', this.onOptionChange.bind(this));
    }

    /**
     * Reagiert auf Klicks
     */
    onOptionChange(evt) {
      // 1. Versuche die exakte Variante zu finden
      let matchedVariant = this.getSelectedVariant();

      // 2. SMART FALLBACK: Wenn die Kombi nicht existiert, finde die nächste passende
      if (!matchedVariant) {
        matchedVariant = this.findBestFallback(evt.target);
        if (matchedVariant) {
          this.syncRadioButtons(matchedVariant);
        }
      }

      this.variant = matchedVariant;

      // 3. UI Updates
      if (this.variant) {
        this.updateMedia();
        this.updatePrice();
        this.updateVariantInput();
        this.updateUrl(evt);
      }

      this.updateAvailability();
      this.updateAddToCartButton();
      this.updateBackorderText();
      this.updateSku();
      VariantPicker.updateLabelText(evt);

      // Event für Drawer/Apps
      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: { variant: this.variant, product: this.data.product }
      }));

      setTimeout(() => this.updateSectionsWithFetching(), 500);
    }

    /**
     * Berechnet die Verfügbarkeit für jeden Button (Strike-through Logik - REINE DOWNWARD LOGIK)
     */
    updateAvailability() {
      const variants = this.data.product.variants;
      const selectedOptions = this.getSelectedOptions();

      this.querySelectorAll(".js-option").forEach((input) => {
        
        // 1. Index sicher auslesen
        let optionIndex = 0;
        const classMatch = input.className.match(/option_index-(\d)/);
        if (classMatch) {
          optionIndex = parseInt(classMatch[1]) - 1; 
        } else {
          const optionSelector = input.closest('.option-selector');
          if (optionSelector && optionSelector.dataset.optionIndex) {
            optionIndex = parseInt(optionSelector.dataset.optionIndex) - 1;
          }
        }
        
        const inputValue = input.value;
        let isAvailable = false;

        // 2. REINE DOWNWARD-LOGIK
        variants.forEach(v => {
          // Wir betrachten nur Varianten, die an dieser Stelle (z.B. Durchmesser) den gesuchten Wert haben
          if (v.options[optionIndex] === inputValue) {
            
            // Wir prüfen NUR die Ebenen, die ÜBER dieser Option stehen
            let matchesHigherLevels = true;
            for (let i = 0; i < optionIndex; i++) {
              if (selectedOptions[i] !== null && v.options[i] !== selectedOptions[i]) {
                matchesHigherLevels = false;
                break;
              }
            }

            // Wenn die Variante zu den oberen Auswahlen passt und auf Lager ist -> als verfügbar markieren!
            if (matchesHigherLevels && v.available) {
              isAvailable = true;
            }
          }
        });

        // 3. KLASSEN & STYLING SETZEN
        input.classList.toggle('is-unavailable', !isAvailable);
        input.disabled = false; // Bleibt immer klickbar!

        let label = this.querySelector(`label[for="${input.id}"]`);
        if (!label && input.nextElementSibling && input.nextElementSibling.classList.contains('opt-label')) {
            label = input.nextElementSibling;
        }

        if (label) {
          label.classList.toggle('is-unavailable', !isAvailable);
          
          // Nichts wird versteckt, alles bleibt sichtbar
          label.classList.remove('opt-label-hide'); 
          label.classList.remove('is-nonexistent'); 
        }
      });
    }

    /**
     * Findet eine Ersatz-Variante, wenn die gewählte Kombi nicht existiert
     */
    findBestFallback(clickedInput) {
      const clickedValue = clickedInput.value;
      const optionIndex = parseInt(clickedInput.closest('.option-selector').dataset.optionIndex) - 1;

      // Suche zuerst nach einer VERFÜGBAREN Variante, die den geklickten Wert enthält
      let fallback = this.data.product.variants.find(v => v.options[optionIndex] === clickedValue && v.available);
      
      // Wenn nichts verfügbar ist, nimm die erste ÜBERHAUPT existierende mit diesem Wert
      if (!fallback) {
        fallback = this.data.product.variants.find(v => v.options[optionIndex] === clickedValue);
      }
      return fallback;
    }

    /**
     * Bringt die Radio-Buttons im UI wieder in Einklang mit der gewählten Variante
     */
    syncRadioButtons(variant) {
      variant.options.forEach((value, index) => {
        const input = this.querySelector(`.option-selector[data-option-index="${index + 1}"] input[value="${value.replace(/"/g, '\\"')}"]`);
        if (input) input.checked = true;
      });
    }

    // --- Standard Hilfsfunktionen ---

    getSelectedOptions() {
      return Array.from(this.querySelectorAll('.option-selector'), (sel) => {
        const checked = sel.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(v => v.options.every((val, i) => val === selectedOptions[i]));
    }

    getProductData() {
      return JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }

    updatePrice() {
      const priceEl = this.section.querySelector('.price__current');
      if (priceEl && this.variant) priceEl.innerHTML = this.data.formatted[this.variant.id].price;
      
      const priceWrapper = this.section.querySelector('.price');
      if (priceWrapper && this.variant) {
        priceWrapper.classList.toggle('price--on-sale', this.variant.compare_at_price > this.variant.price);
        priceWrapper.classList.toggle('price--sold-out', !this.variant.available);
      }
    }

    updateMedia() {
      if (!this.variant || !this.variant.featured_media) return;
      const target = this.section.querySelector(`[data-media-id="${this.variant.featured_media.id}"]`);
      if (target) {
        this.section.querySelectorAll('[data-media-id]').forEach(img => img.hidden = true);
        target.hidden = false;
      }
    }

    updateVariantInput() {
      const input = this.section.querySelector('input[name="id"]');
      if (input) {
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateAddToCartButton() {
      const addBtn = this.section.querySelector('[name="add"]');
      if (!addBtn) return;
      addBtn.disabled = !this.variant || !this.variant.available;
      const label = this.variant ? (this.variant.available ? addBtn.dataset.addToCartText : theme.strings.noStock) : theme.strings.noVariant;
      addBtn.textContent = label;
    }

    updateUrl(evt) {
      if (evt && evt.type === 'change' && this.dataset.updateUrl !== 'false') {
        window.history.replaceState({}, '', `${window.location.pathname}?variant=${this.variant.id}`);
      }
    }

    updateSectionsWithFetching() {
        if (!this.variant) return;
        fetch(`${window.location.pathname}?variant=${this.variant.id}`)
        .then(r => r.text()).then(htmlStr => {
            const html = new DOMParser().parseFromString(htmlStr, 'text/html');
            const dest = this.section.querySelector('#delivery-status');
            const src = html.querySelector('#delivery-status');
            if (src && dest) dest.innerHTML = src.innerHTML;
        });
    }

    updateBackorderText() {} // Optional implementieren
    updateSku() {
        const el = this.section.querySelector('.product-sku__value');
        if (el) el.textContent = this.variant ? this.variant.sku : '';
    }

    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      const textSpan = selector ? selector.querySelector('.js-color-text') : null;
      if (textSpan) textSpan.textContent = evt.target.value;
    }
  }
  customElements.define('variant-picker', VariantPicker);
}